export { getAssetFieldValueElementClass } from './web-component';
